<template>
  <div>
    <personal-info></personal-info>
    <div class="container mt-5 information-list">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-3 mt-2">
            <div class="list-group">
              <div v-show="permission.includes('basic-information') === true">
                <button
                  type="button"
                  data-toggle="button"
                  aria-pressed="false"
                  class="btn btn-primary list-group-item list-group-item-action"
                  :class="activeButton1"
                  @click="showPage(1)"
                >
                  Basic Information
                </button>
              </div>
              <div v-show="permission.includes('vehicle-information') === true">
                <button
                  type="button"
                  data-toggle="button"
                  aria-pressed="false"
                  class="btn btn-primary list-group-item list-group-item-action"
                  :class="activeButton2"
                  @click="showPage(2)"
                >
                  Vehicle Information
                </button>
              </div>
              <div v-show="permission.includes('documents') === true">
                <button
                  type="button"
                  data-toggle="button"
                  aria-pressed="false"
                  class="btn btn-primary list-group-item list-group-item-action"
                  :class="activeButton3"
                  @click="showPage(3)"
                >
                  Documents
                </button>
              </div>

              <div v-show="permission.includes('payment-history') === true">
                <button
                  type="button"
                  data-toggle="button"
                  aria-pressed="false"
                  class="btn btn-primary list-group-item list-group-item-action"
                  :class="activeButton4"
                  @click="showPage(4)"
                >
                  Payment History
                </button>
              </div>
              <div v-show="permission.includes('trip-history') === true">
                <button
                  type="button"
                  data-toggle="button"
                  aria-pressed="false"
                  class="btn btn-primary list-group-item list-group-item-action"
                  :class="activeButton5"
                  @click="showPage(5)"
                >
                  Trip History
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-9">
            <div v-if="className == 1">
              <basic-information></basic-information>
            </div>
            <div v-if="className == 2">
              <vehicle-information></vehicle-information>
            </div>
            <div v-if="className == 3">
              <document></document>
            </div>
            <div v-if="className == 4">
              <payment-history></payment-history>
            </div>
            <div v-if="className == 5">
              <trip-history></trip-history>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PersonalInfo from '../components/partnerProfile/PersonalInfo';
import BasicInformation from '../components/partnerProfile/BasicInformation';
import VehicleInformation from '../components/partnerProfile/VehicleInformation';
import Document from '../components/partnerProfile/Document';
import PaymentHistory from '../components/partnerProfile/PaymentHistory';
import TripHistory from '../components/partnerProfile/TripHistory';

export default {
  name: 'PartnerProfile',
  components: {
    PersonalInfo: PersonalInfo,
    VehicleInformation: VehicleInformation,
    BasicInformation: BasicInformation,
    Document: Document,
    PaymentHistory: PaymentHistory,
    TripHistory: TripHistory
  },
  data() {
    return {
      isBasicInformation: false,
      isVehicleInformation: false,
      isDocuments: false,
      isPaymentHistory: false,
      isTripHistory: false,
      className: 1,
      vehicleDoc: null,
      activeButton1: 'active',
      activeButton2: '',
      activeButton3: '',
      activeButton4: '',
      activeButton5: '',
      permission: ''
    };
  },
  created() {
    this.getVehicleInfo();
  },
  mounted() {
    this.permission = localStorage.getItem('userPermission').split(',');
  },
  methods: {
    showPage(id) {
      this.className = id ? id : 1;
      if (id == 1) {
        this.activeButton2 = '';
        this.activeButton3 = '';
        this.activeButton4 = '';
        this.activeButton5 = '';
        this.activeButton1 = 'active';
      }
      if (id == 2) {
        this.activeButton1 = '';
        this.activeButton3 = '';
        this.activeButton4 = '';
        this.activeButton5 = '';
        this.activeButton2 = 'active';
      }
      if (id == 3) {
        this.activeButton1 = '';
        this.activeButton2 = '';
        this.activeButton4 = '';
        this.activeButton5 = '';
        this.activeButton3 = 'active';
      }
      if (id == 4) {
        this.activeButton1 = '';
        this.activeButton2 = '';
        this.activeButton3 = '';
        this.activeButton5 = '';
        this.activeButton4 = 'active';
      }
      if (id == 5) {
        this.activeButton1 = '';
        this.activeButton2 = '';
        this.activeButton3 = '';
        this.activeButton4 = '';
        this.activeButton5 = 'active';
      }
    },
    getVehicleInfo(data) {
      this.vehicleDoc = data ? data : 'null';
    }
  }
};
</script>

<style scoped>
.information-list {
  list-style-type: none;
}

.btn-primary:hover {
  background-color: #ffffff;
  color: #25262b; /* new color goes her */
  border-color: #25262b;
}

.btn-primary.focus,
.btn-primary:focus {
  color: #f0f0f0;
  background-color: #1c2457; /* new color goes her */
  border-color: #1c2457;
}

.active {
  color: #f0f0f0;
  background-color: #1c2457; /* new color goes her */
  border-color: #1c2457;
}
</style>
